module.exports = __webpack_public_path__ + "static/media/report-dark.5802b914.svg";